import { useAuth } from "./useAuth";
import { useQuery } from "react-query";
import { School } from "../models/school/school";
import { useTeachers } from "../states/cache-state/useTeachers";
import { useSchoolApi } from "../apis/school-api";

const useAuthData = () => {
  const { user } = useAuth();
  const { getTeacher } = useTeachers();
  const { getSchool } = useSchoolApi();

  const { data: currentTeacher } = useQuery(
    ["currentTeacher", user?.email],
    () => getTeacher(user!.email).catch(() => undefined),
    {
      enabled: !!user && user.roles.includes("TEACHER"),
      cacheTime: 60 * (60 * 1000), // 1h
      staleTime: 60 * (60 * 1000), // 1h
    },
  );

  const { data: currentSchool } = useQuery<School>(
    ["school"],
    async () => {
      if (!user || user?.schoolIds.length === 0) {
        throw Error(
          "User has no assigned schools. Please assign at least one school to the user.",
        );
      }
      return await getSchool(user.schoolIds[0]);
    },
    {
      enabled: !!user,
      cacheTime: 60 * (60 * 1000), // 1h
      staleTime: 60 * (60 * 1000), // 1h
    },
  );

  return {
    currentTeacher,
    currentSchool,
  };
};

export default useAuthData;
